"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var Text_1 = __importDefault(require("shared/components/Text"));
var InsightText = (0, material_1.styled)(Text_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'color'; },
})(function (_a) {
    var theme = _a.theme, color = _a.color;
    return (__assign(__assign({}, theme.typography.h3), { color: color === 'success' ? theme.palette.success.dark : theme.palette.secondary.dark }));
});
exports.default = (0, DefaultPropsHoC_1.default)(InsightText, { level: 1, component: 'span' });
